import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { App } from '../../modules/App';

export const Legal = (function () {
  const $eulaFiles = $config.eulaFiles;

  let init = (params = {}, query = '') => {
    UI.blockPage();

    $.when(
      App.ajaxFileContent($eulaFiles.path + $eulaFiles.ULA),
      App.ajaxFileContent($eulaFiles.path + $eulaFiles.CP),
      App.ajaxFileContent($eulaFiles.path + $eulaFiles.IPP),
      App.ajaxFileContent($eulaFiles.path + $eulaFiles.PP),
      App.ajaxFileContent($eulaFiles.path + $eulaFiles.TOU)
    )
      .done((ULA, CP, IPP, PP, TOU) => {
        let active = currentPage(params.action); // - Active tab
        let data = {
          ULA: clearHtml(ULA),
          CP: clearHtml(CP),
          IPP: clearHtml(IPP),
          PP: clearHtml(PP),
          TOU: clearHtml(TOU),
          active: active,
          pagetitle: $lang.Legal[active]
        };

        let template = require('./tmpl/legal.hbs');
        UI.page(template, data).then(() => {
          // SET Url on new tab sown
          $('.nav-tabs-vertical a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            history.replaceState(null, '', `/legal/${$(e.target).attr('href').replace('#', '')}`);
          });

          UI.unblockPage();
        });
      })
      .fail(() => {
        UI.errorMessage('File not found');
      });
  };

  let dialog = (name = 'ULA') => {
    return new Promise((resolve, reject) => {
      UI.blockPage();
      $.when(App.ajaxFileContent($eulaFiles.path + $eulaFiles[name]))
        .done((res) => {
          let data = {
            $lang: $lang,
            Html: clearHtml(res),
            name: name
          };

          let template = require('./tmpl/dialog.hbs');
          bootbox
            .dialog({
              title: $lang.Legal[name],
              message: template(data),
              size: 'xl',
              className: 'modal-scrolled-content modal-legal-page',
              onEscape: () => {
                return reject('User close');
              }
            })
            .init(() => {
              UI.unblockPage();
              $('#ContinueBtn' + name)
                .off()
                .on('click', () => {
                  bootbox.hideAll();
                  return resolve('Agree');
                });
            });
        })
        .fail(() => {
          UI.errorMessage('File not found');
          return reject('File not found');
        });
    });
  };

  let currentPage = (param) => {
    let active = 'ULA';
    if (param) {
      switch (param) {
        case 'CP':
          active = 'CP';
          break;
        case 'IPP':
          active = 'IPP';
          break;
        case 'PP':
          active = 'PP';
          break;
        case 'TOU':
          active = 'TOU';
          break;
        default:
          active = 'ULA';
      }
    }
    return active;
  };

  let clearHtml = (str) => {
    let matches = str.match(/<body[^>]*>((.|[\n\r])*)<\/body>/im);

    str = matches.length > 0 ? matches[1] : str;

    let $html = $(str);
    $html.removeAttr('class').removeAttr('dir').removeAttr('style').removeAttr('align').removeAttr('lang');
    $('div, p, span', $html)
      .removeAttr('class')
      .removeAttr('dir')
      .removeAttr('style')
      .removeAttr('align')
      .removeAttr('lang');

    return $html.html();
  };

  return {
    init,
    dialog
  };
})();
